import React, { Component } from "react";
import { useSelector } from "react-redux";
import ModalImage from "react-modal-image";
import FileImagePreview from './FileImagePreview';

export default function File({file, message, i}) {

  const uuid = useSelector(state => state.uuid.uuid);

  if (file.type == 2) {
    return (
      <FileImagePreview file={file} message={message} i={i} />
    );
  }

  return (
    <a href={`${file.urlClient}?uuid=${uuid}`} target="_blank" key={file.id} className="kil-chat-widget-conversation-files-file">
      {/* <div className="kil-chat-widget-conversation-files-file-download">
        <a href={`${file.url}?uuid=${uuid}`} target="_blank">
          <i className="fal fa-download"></i>
        </a>
      </div> */}
      <div className="file-wrapper">
        <div className="file-icon">
          <i className="fas fa-file"></i>
          {'\u00A0'}{'\u00A0'}
          <span>{file.name}</span>
        </div>
      </div>
    </a> 
  )
}